module.exports = __webpack_public_path__ + "img/receipt.cb33494.svg";